import axiosClient from '../../../config/axios-client'
import { seequentSponsor } from '../data/staticSponsors'

const SponsorService = {
  getSponsorsLogos() {
    return axiosClient.get(`/platform/sponsors/logos`)
  },
  getSponsorTypes() {
    return axiosClient.get(`/platform/sponsors`)
  },
  getPackages() {
    return axiosClient.get(`/platform/sponsors/packages`)
  },
  getSponsor(sponsorSlug) {
    if (sponsorSlug === seequentSponsor.slug) {
      return Promise.resolve({ data: { sponsor: seequentSponsor } })
    }
    return axiosClient.get(`/platform/sponsors/${sponsorSlug}`)
  },
  createSponsorRequest(payload) {
    return axiosClient.post(`/platform/sponsors/requests`, payload)
  },
}

export default SponsorService
